import { LOGIN_USER, REMOVE_TOKEN, REMOVE_USERS, SET_ORGANIZATION, SET_TOKEN } from "../types"

const loginUser = (user) => {
    return {
        type: LOGIN_USER,
        user
    }
}
const setOrganization = (organization) => ({
    type: SET_ORGANIZATION,
    payload: organization,
});

const authToken = (token) => ({
    type: SET_TOKEN,
    payload: token,
})

const removeUser = () => {
    return {
        type: REMOVE_USERS
    }
}

const removeToken = () => {
    return {
        type: REMOVE_TOKEN
    }
}
export {
    loginUser,
    removeUser,
    authToken,
    removeToken,
    setOrganization
}